import { supabase } from './supabase.js';
import { resolveAdminInvokeError } from './adminActionsInvoke.js';

/**
 * Envío carrusel a Telegram: valida publicaciones en servidor y POST a n8n.
 * @param {{ tipo: 'noticias' | 'eventos', ids: string[] }} params
 */
export async function prepareInstagramCarousel(params) {
  const tipo = params.tipo;
  const ids = Array.isArray(params.ids) ? params.ids.filter(Boolean) : [];
  if (!ids.length) {
    return { ok: false, error: 'Selecciona al menos una publicación.' };
  }

  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: {
      action: 'instagram_carousel_prepare',
      payload: { tipo, ids },
    },
  });

  if (error) {
    return {
      ok: false,
      error: await resolveAdminInvokeError(
        error,
        data,
        'No se pudo enviar el carrusel. Revisa n8n y los secrets N8N_ENVIO_CAROUSEL_* en Supabase.',
      ),
    };
  }
  if (!data?.ok) {
    return {
      ok: false,
      error: (data && typeof data.message === 'string' && data.message) || data?.error || 'Envío rechazado.',
    };
  }
  return { ok: true, count: data.count ?? ids.length };
}
